import React, { useRef } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useRouter } from 'next/router';

export default function ModuleBox(props) {
  const router = useRouter();
  const subtitleText = useRef(null);

  const imgUrl =
    props.imgUrl === undefined
      ? 'https://via.placeholder.com/384x216'
      : props.imgUrl;
  const imgDesc = props.imgDesc === undefined ? '이미지 설명' : props.imgDesc;

  const mainTitle = props.main_title;

  const date = props.date || '';
  const buttons = props.buttons || [];

  if (subtitleText && subtitleText.current) {
    subtitleText.current.innerHTML = props.desc || '';
  }

  function checkClickParams(index, linkUrl) {
    
    
    const key = 'div';
    let value = '';
    if (index === 0) {
      value = 'main_top_home';
    } else {
      value = 'main_top_menu';
    }

    if (linkUrl.indexOf('http') === -1) {
      router.query[key] = value;

      const parameter = Object.keys(router.query)
        .map(function (x) {
          return (
            encodeURIComponent(x) + '=' + encodeURIComponent(router.query[x])
          );
        })
        .join('&');

      linkUrl = `${linkUrl}?${parameter}`;
    } else {
      const httpUrl = new URL(linkUrl);
      const httpUrlSearchParams = httpUrl.searchParams;
      
      httpUrlSearchParams.set(key, value);
      httpUrl.search = httpUrlSearchParams.toString();
      
      try {
        var findQ = linkUrl.indexOf('?');
        if(findQ!==-1){
           const originalurl = linkUrl.substring(0, linkUrl.indexOf('?'));
           linkUrl = `${originalurl}${httpUrl.search}`;
           linkUrl = linkUrl.replace(/\+/g, "%20");
        }else{
          linkUrl = `${linkUrl}${httpUrl.search}`;
          linkUrl = linkUrl.replace(/\+/g, "%20");
        }
      } catch (error) {
        console.error(error);
      }
    }
    return linkUrl;
  }

  return (
    <>
      <div className="mvsl_content">
        <div className="mvsl_cont">
          {mainTitle && (
            <em
              className="mvsl_text_title"
              dangerouslySetInnerHTML={{ __html: mainTitle }}
            />
          )}
          {props.desc && (
            <strong className="mvsl_text_subtitle" ref={subtitleText} />
          )}
          {date && <p className="mvsl_subinfo">{date}</p>}
          <div className={`${buttons ? 'btn_roundtype_w' : ''}`}>
            {Array.isArray(buttons) &&
              buttons.length > 0 &&
              buttons.map((item, index) => {
                // 여기서는 앵커 태그를 사용하자 앵커아니고 Link 사용시 오류남
                return (
                  <a
                    target={
                      item.home_link_new_yn === 'Y' ||
                      item.menu_link_new_yn === 'Y'
                        ? '_blank'
                        : ''
                    }
                    key={index}
                    href={`${checkClickParams(index, item.link)}`}
                    tabIndex={props.index === props.currentIndex ? '0' : '-1'}
                    className={`btn_roundtype_color_${item.color || 'white'}`}
                    onMouseOver={(e) => props.moveSlide('onmouse_pause')}
                    onMouseOut={(e) => props.moveSlide('play')}
                  >
                    <span className="btn_rtc_text">{item.text}</span>
                  </a>
                );
              })}
          </div>
        </div>
        <i className="mvsl_bg">
          {props.imageQuality === 100 ? (
            <img
              src={imgUrl || 'https://via.placeholder.com/150x150?text=SBS'}
              alt={imgDesc}
            />
          ) : (
            <Image
              src={imgUrl || 'https://via.placeholder.com/150x150?text=SBS'}
              alt={imgDesc}
              layout="fill"
              quality={props.imageQuality || '75'}
              style={{ width: '100%', height: '100%' }}
            />
          )}
        </i>
      </div>
    </>
  );
}
